export default {
  kPotassiumUnit: null,
  pUnit: null,
  uricAcidUnit: null,
  albuminUnit: null,
  totalProteinUnit: null,
  diseaseUnit: [],
  __typename: 'ConsultationPersonalDetail'
};
